import strFunc from "@/lib/lyg/string";
import ArrFunc from '@/lib/lyg/arr_func';
import React from 'react';
import StuNameTd from "./area/stu/stu_name_td";
import AttendTd from "./area/stu/attend_td";
import TodoHomeWorkTd from "./area/stu/todo_home_work";
import DailyInputText from "./area/daily/input_text";
import MonthPrescribeStateTd from "./area/month_prescribe/state_td";
import DailyDataFunc from "@/pages/comp/edu/daily_report/card_list/func/daily_data_func";
import DailyPrescribeAera from "./area/daily_prescribe";
import StudyTitleAswer from "./area/daily/answer";
import TodoTestTd from "./area/stu/todo_test";

function CardBoxArea(props: any) {
  let myProps = {
    row_num: 0,
    first_td_tag: "",
    lecture_info: null,
    subject_name: "",
    info: {},
    set_info: (info: any) => { },
    is_print_mode: false,
    is_focus_row: false,
    xColumnArr: {},
    select_date: "",
    pre_date_str: "",
    list: (inData: any) => { },
    check_row_val_arr: [],
    set_check_row_val_arr: (inData: any) => { },
    is_check_show_textarea: false,
    is_show_daily_prescribe: false,
    show_daily_prescribe_stu_subject_arr: [],
    set_show_daily_prescribe_stu_subject_arr: (inData: any) => { },
    Style: {},
    show_week_arr: [],
    lecture_time_str: "",
    select_stu_grade_arr: [],
    select_homework_state_arr: [],
    save_daily_report_by_stu_arr: (inData: any) => { },
    save_daily_prescribe_by_stu_arr: (inData: any) => { },
    delete_daily_prescribe_by_stu_arr: (inData: any) => { },
    on_click_tr_row: (inData: any) => { },
    openAttendPopup: (inData: any) => { },
    deleteAttend: (inData: any) => { },
    open_write_td_data_popup: (inData: any) => { },
    open_write_td_memo_popup: (inData: any) => { },
    openTodoDaySort: (inData: any) => { },
    open_stu_layer_popup: (inData: any) => { },
    open_find_study_title_popup: (inData: any) => { },
    open_todo_word_result_one_popup: (inData: any) => { },
    ...props
  };
  let Style = myProps.Style;
  let info = myProps.info;
  let daily_report_arr = [];
  if (info.daily_report_arr) {
    daily_report_arr = info.daily_report_arr;
  }
  let xColumnArr = myProps.xColumnArr;

  let lecture_info: any = null;
  let lecture_seq = "";
  if (!strFunc.is_empty(myProps.lecture_info)) {
    lecture_info = myProps.lecture_info;
    lecture_seq = lecture_info["a_seq"];
  }
  let subject_name = myProps.subject_name;
  let lecture_time_str = myProps.lecture_time_str;
  let card_row_pri_val = info["a_seq"] + "," + lecture_seq + "," + lecture_time_str + "," + subject_name;
  let stu_subject_str = info["a_seq"] + "," + subject_name;
  let is_show_daily_prescribe_row = false;
  if (strFunc.str_in_array(stu_subject_str, myProps.show_daily_prescribe_stu_subject_arr) != -1) {
    is_show_daily_prescribe_row = true;
  }

  let last_daily_info = {
    a_stu_seq: "",
    a_writer_seq: "",
    a_lecture_seq: "",
    a_textbook: "",
    a_subtextbook: "",
    a_homework: "",
  };
  if (info.last_daily_report_arr && info.last_daily_report_arr.length > 0 && lecture_info != null) {
    for (let i = 0; i < info.last_daily_report_arr.length; i++) {
      let row_daily_info = info.last_daily_report_arr[i];
      if (row_daily_info["a_stu_seq"] == info["a_seq"]
        //&& row_daily_info["a_writer_seq"] == lecture_info["a_main_teacher_seq"]
        && row_daily_info["a_lecture_seq"] == lecture_info["a_seq"]
        && strFunc.is_empty(last_daily_info["a_stu_seq"])) {
        last_daily_info = row_daily_info;
      }
    }
  }
  let daily_info = DailyDataFunc.get_daily_info_of_date({
    date_str: myProps.select_date,
    pre_date_str: myProps.pre_date_str,
    last_daily_info: last_daily_info,
    lecture_time_str: myProps.lecture_time_str,
    info: info,
    lecture_info: lecture_info,
    subject: subject_name,
  });

  let daily_prescribe_info = DailyDataFunc.get_daily_prescribe_of_subject({
    stu_info: info,
    date_str: myProps.select_date,
    pre_date_str: myProps.pre_date_str,
    subject: subject_name,
  });

  let daily_prescribe_date_style: any = {};
  let daily_prescribe_date = "";
  if (!strFunc.is_empty(daily_prescribe_info["a_seq"])) {
    daily_prescribe_date = daily_prescribe_info["a_write_date"].substring(5, 10);
    daily_prescribe_date_style["background"] = "#a2b854";
  } else {

    if (daily_prescribe_info["a_write_date"] != myProps.select_date) {
      daily_prescribe_date = daily_prescribe_info["a_write_date"].substring(5, 10);
      daily_prescribe_date_style["background"] = "";
    } else {
      if (daily_prescribe_info.last_info && daily_prescribe_info.last_info.a_write_date) {
        daily_prescribe_date = daily_prescribe_info.last_info["a_write_date"].substring(5, 10);
      }
    }
  }

  let is_checked_row = false;
  if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) != -1) {
    is_checked_row = true;
  }

  const on_checkbox_change = (e: any) => {
    if (e.target.checked) {
      let change_check_row_val_arr = myProps.check_row_val_arr;
      change_check_row_val_arr.push(card_row_pri_val);
      myProps.set_check_row_val_arr(change_check_row_val_arr);
    } else {
      let change_check_row_val_arr = [];
      for (let i = 0; i < myProps.check_row_val_arr.length; i++) {
        if (myProps.check_row_val_arr[i] != card_row_pri_val) {
          change_check_row_val_arr.push(myProps.check_row_val_arr[i]);
        }
      }
      myProps.set_check_row_val_arr(change_check_row_val_arr);
    }
  };

  const on_td_click = (inData: any) => {
    let opt_obj = {
      name: "",
      ...inData
    };
    let name = opt_obj.name;
    if (name == "row_view_checkbox") {
      on_checkbox_change({
        target: {
          checked: !is_checked_row
        }
      });
    }
  };

  const on_change_daily_input = (inData: any) => {
    let opt_obj = {
      name: "",
      value: "",
      change_row_data: {},
      is_save: false,
      is_show_loading: false,
      ...inData
    };
    if (myProps.is_print_mode) {
      return false;
    }
    let value = opt_obj.value;
    let name = opt_obj.name;
    let daily_row_num = -1;
    if (info.daily_report_arr && info.daily_report_arr.length > 0) {
      for (let i = 0; i < info.daily_report_arr.length; i++) {
        let row_daily_info = info.daily_report_arr[i];
        if (!strFunc.is_empty(daily_info["a_seq"])) {
          if (row_daily_info["a_ymd"] == daily_info["a_ymd"]
            && row_daily_info["a_seq"] == daily_info["a_seq"]) {
            daily_row_num = i;
          }
        } else {
          if (row_daily_info["a_lecture_seq"] == daily_info["a_lecture_seq"]
            && row_daily_info["a_stu_seq"] == daily_info["a_stu_seq"]
            && row_daily_info["a_date"] == daily_info["a_date"]
            && row_daily_info["a_lecture_time"] == daily_info["a_lecture_time"]) {
            daily_row_num = i;
          }
        }
      }
    }

    daily_info[name] = value;
    for (let key in opt_obj.change_row_data) {
      daily_info[key] = opt_obj.change_row_data[key];
    }

    if (daily_row_num != -1) {
      info.daily_report_arr[daily_row_num] = daily_info;
    }
    if (daily_row_num == -1) {
      if (info.daily_report_arr == undefined) {
        info.daily_report_arr = [];
      }
      info.daily_report_arr.push(daily_info);
    }

    if (name == "a_homework_state" || name == "a_study_state") {
      myProps.save_daily_report_by_stu_arr({
        report_data_arr: [daily_info],
        is_show_loading: true,
      });
    } else if (opt_obj.is_save) {
      myProps.save_daily_report_by_stu_arr({
        report_data_arr: [daily_info],
        is_show_loading: opt_obj.is_show_loading
      });
    }
    myProps.set_info(info);
  };

  let get_td_tag_by_data = (inData: any) => {
    let opt_obj = {
      key: "",
      td_render: "",
      ...inData
    };
    let key = opt_obj.key;
    let td_render = opt_obj.td_render;

    let td_class_name = "text-center";
    if (info.attend_state_str == "결석") {
      td_class_name += " " + Style.disable_td;
    }
    if (myProps.is_check_show_textarea) {
      td_class_name += " td_v_top";
    }

    let row_td_style: any = {

    };
    if (key == "row_view_attend") {
      let attend_color: any = info["attend_color"];
      row_td_style["backgroundColor"] = attend_color;
    } else if (key == "row_view_stu_name") {
      if (is_checked_row) {
        row_td_style["background"] = "#cbcbcb";
      }
    }

    if (key == "row_view_checkbox") {
      td_render = (
        <input
          type="checkbox"
          onChange={on_checkbox_change}
          value={""}
          checked={is_checked_row}
        />
      );
    } else if (key == "row_view_stu_name") {
      td_render = (
        <StuNameTd
          Style={Style}
          info={info}
          daily_info={daily_info}
          select_stu_grade_arr={myProps.select_stu_grade_arr}
          subject_name={subject_name}
          open_stu_layer_popup={myProps.open_stu_layer_popup}
          openTodoDaySort={myProps.openTodoDaySort}
        ></StuNameTd>
      );
    } else if (key == "row_view_month_prescribe") {
      td_render = (
        <div>
          <button className="btn btn-gray"
            onClick={() => {
              if (is_show_daily_prescribe_row) {
                let new_show_daily_prescribe_stu_subject_arr = ArrFunc.get_remove_arr_by_value({
                  arr: myProps.show_daily_prescribe_stu_subject_arr,
                  except_val_arr: [stu_subject_str]
                });
                myProps.set_show_daily_prescribe_stu_subject_arr(new_show_daily_prescribe_stu_subject_arr);
              } else {
                let change_show_daily_prescribe_stu_subject_arr = [...myProps.show_daily_prescribe_stu_subject_arr];
                change_show_daily_prescribe_stu_subject_arr.push(stu_subject_str);
                myProps.set_show_daily_prescribe_stu_subject_arr(change_show_daily_prescribe_stu_subject_arr);
              }
            }}
            style={daily_prescribe_date_style}>
            {daily_prescribe_date ? daily_prescribe_date : "+"}
          </button>
        </div>
      );
    } else if (key == "row_view_attend") {
      td_render = (
        <AttendTd
          info={info}
          openAttendPopup={myProps.openAttendPopup}
          deleteAttend={myProps.deleteAttend}
        ></AttendTd>
      );
    } else if (key == "row_view_todo_study") {
      td_render = (
        <TodoHomeWorkTd
          Style={Style}
          info={info}
          is_check_show_textarea={myProps.is_check_show_textarea}
          is_checked_row={is_checked_row}
          select_date={myProps.select_date}
          pre_date_str={myProps.pre_date_str}
          openTodoDaySort={myProps.openTodoDaySort}
          sort="study"
          subject_name={subject_name}

          daily_info={daily_info}
          onChange={on_change_daily_input}
          select_homework_state_arr={myProps.select_homework_state_arr}
        ></TodoHomeWorkTd>
      );
    } else if (key == "row_view_todo_homework") {
      td_render = (
        <TodoHomeWorkTd
          Style={Style}
          info={info}
          is_check_show_textarea={myProps.is_check_show_textarea}
          is_checked_row={is_checked_row}
          select_date={myProps.select_date}
          pre_date_str={myProps.pre_date_str}
          openTodoDaySort={myProps.openTodoDaySort}
          sort="pre_homework"
          subject_name={subject_name}

          daily_info={daily_info}
          onChange={on_change_daily_input}
          select_homework_state_arr={myProps.select_homework_state_arr}
        ></TodoHomeWorkTd>
      );
    } else if (key == "row_view_todo_test") {
      td_render = (
        <TodoTestTd
          Style={Style}
          info={info}
          is_check_show_textarea={myProps.is_check_show_textarea}
          is_checked_row={is_checked_row}
          select_date={myProps.select_date}
          pre_date_str={myProps.pre_date_str}
          sort="pre_homework"
          subject_name={subject_name}

          daily_info={daily_info}
          open_todo_word_result_one_popup={myProps.open_todo_word_result_one_popup}
        ></TodoTestTd>
      );
    } else if (key == "row_view_homework") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_homework"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClick={() => {
            if (myProps.is_check_show_textarea) {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_textbook") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_textbook"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClickLeft={() => {
            myProps.open_find_study_title_popup({
              row_num: info["a_seq"],
              key_str: "a_textbook",
              par_info: daily_info
            });
          }}
          onClick={() => {
            if (myProps.is_check_show_textarea) {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_textbook_answer") {
      td_render = (
        <StudyTitleAswer
          info={info}
          daily_info={daily_info}
        ></StudyTitleAswer>
      );
    } else if (key == "row_view_textbook_study") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_textbook_study"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClick={() => {
            if (myProps.is_check_show_textarea) {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_textbook_study_det") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_textbook_study_det"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClick={() => {
            if (myProps.is_check_show_textarea) {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_subtextbook") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_subtextbook"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          // onClick={() => {
          //   myProps.open_find_study_title_popup({
          //     row_num: info["a_seq"],
          //     key_str: "a_subtextbook",
          //     par_info: daily_info
          //   });
          //   if (myProps.is_check_show_textarea) {
          //     if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
          //       || myProps.check_row_val_arr.length != 1) {
          //       myProps.set_check_row_val_arr([card_row_pri_val]);
          //     }
          //   }
          // }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "a_study_amount_memo") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_study_amount_memo"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClick={() => {
            if (myProps.is_check_show_textarea) {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_memo") {
      td_render = (
        <DailyInputText
          Style={Style}
          info={info}
          daily_info={daily_info}
          name="a_memo"
          is_checked_row={is_checked_row}
          is_check_show_textarea={myProps.is_check_show_textarea}
          onChange={on_change_daily_input}
          onClick={() => {
            if (myProps.is_check_show_textarea == false) {
              myProps.open_write_td_memo_popup({
                daily_report: daily_info,
                td_sort: "a_memo"
              });
            } else {
              if (strFunc.str_in_array(card_row_pri_val, myProps.check_row_val_arr) == -1
                || myProps.check_row_val_arr.length != 1) {
                myProps.set_check_row_val_arr([card_row_pri_val]);
              }
            }
          }}
          is_print_mode={myProps.is_print_mode}
        ></DailyInputText>
      );
    } else if (key == "row_view_manage") {
      let manage_btn_text = "저장";
      let save_btn_class_name = "btn-s btn-gray";
      if (!strFunc.is_empty(daily_info["a_seq"])) {
        manage_btn_text = "수정";
        save_btn_class_name = "btn-s btn-yellowish2";
      }

      td_render = (
        <div>
          {info.attend_state_str != "결석" &&
            <button className={save_btn_class_name} onClick={() => {
              myProps.save_daily_report_by_stu_arr({
                report_data_arr: [daily_info]
              });
            }}>{manage_btn_text}</button>
          }
        </div>
      );
    } else {
      td_render = (
        <div>
          {td_render}
        </div>
      );
    }
    td_render = (
      <td className={td_class_name}
        onClick={() => {
          on_td_click({
            name: key,
          });
        }} style={row_td_style}>
        {td_render}
      </td>
    );

    return td_render;
  };

  let get_td_tags = () => {
    let td_tags = xColumnArr.x_column_list_arr.map((item: any, idx: number) => {
      if (item["key"] == "row_view_time") { return false; }
      if (item["is_show"] != "1") { return false; }

      let td_render: any = get_td_tag_by_data({
        key: item["key"],
      });

      return (
        <React.Fragment key={idx}>
          {td_render}
        </React.Fragment>
      );
    });
    return td_tags;
  };

  let tr_class_name = Style.card_box_first_tr;
  if (myProps.is_focus_row) {
    if (myProps.is_print_mode == false) {
      //tr_class_name += " " + Style.card_focused_tr;
    }
  }

  return (
    <>
      <tr className={tr_class_name} onClick={() => {
        myProps.on_click_tr_row({});
      }}>
        {myProps.row_num == 0 && myProps.first_td_tag}
        {get_td_tags()}
      </tr>
      {(myProps.is_show_daily_prescribe || is_show_daily_prescribe_row) &&
        <tr>
          <td colSpan={15} style={{ padding: "0px" }} >
            <DailyPrescribeAera
              Style={Style}
              select_date={myProps.select_date}
              pre_date_str={myProps.pre_date_str}
              subject_name={subject_name}
              daily_prescribe_info={daily_prescribe_info}
              info={info}
              set_info={myProps.set_info}
              save_daily_prescribe_by_stu_arr={myProps.save_daily_prescribe_by_stu_arr}
              delete_daily_prescribe_by_stu_arr={myProps.delete_daily_prescribe_by_stu_arr}
            ></DailyPrescribeAera>
          </td>
        </tr>
      }
    </>
  );
};
export default CardBoxArea;